import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-2 my-6 flex flex-col space-y-6" }
const _hoisted_2 = { class: "flex flex-col lg:flex-row items-start justify-center space-y-6 lg:space-y-0 lg:space-x-6" }

import { ref } from 'vue';
import { useRoute } from 'vue-router';
import HomeProfile from './components/HomeProfile.vue';
import HomeProgress from '../../components/HomeProgress.vue';
import LastConversations from '../../components/LastConversations.vue';
import UpcomingAppointments from './components/UpcomingAppointments.vue';
import PreferredLender from './components/PreferredLender.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const homeId = route.params.homeId as string;

const homes = ref<any>({
  activeHome: {},
});
const auth = ref({
  currentUser: {
    authenticated: true,
    data: [],
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (homes.value.activeHome && auth.value.currentUser)
      ? (_openBlock(), _createBlock(HomeProfile, {
          key: 0,
          home: homes.value.activeHome,
          user: auth.value.currentUser
        }, null, 8, ["home", "user"]))
      : _createCommentVNode("", true),
    (homes.value.activeHome && auth.value.currentUser)
      ? (_openBlock(), _createBlock(HomeProgress, {
          key: 1,
          home: homes.value.activeHome,
          user: auth.value.currentUser
        }, null, 8, ["home", "user"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(LastConversations, { homeId: _unref(homeId) }, null, 8, ["homeId"]),
      _createVNode(UpcomingAppointments, { homeId: _unref(homeId) }, null, 8, ["homeId"])
    ]),
    _createVNode(PreferredLender)
  ]))
}
}

})